import $$ from 'cmn-utils'
import leader from "./leader"
import v2 from "./v2"
import group from "./group"


const baseUrl = "/api/sys/unit/";
export default {
    // create: (params) => {
    //     formatUnitParams(params)
    //     return $$.post(baseUrl + 'create', params)
    // },
    // delete: (params) => {
    //     return $$.post(baseUrl + 'delete', params)
    // },
    // get: (params) => {
    //     return $$.get(baseUrl + 'get', params)
    // },
    // getOrgans: (params) => {
    //     return $$.get(baseUrl + 'get-organs', params)
    // },
    // getUserNumber: (params) => {
    //     return $$.get(baseUrl + 'get-user-number', params)
    // },
    // list: (params) => {
    //     Object.keys(params).map(key => {
    //         if (!params[key] || params[key] == 'null' || params[key] == 'undefined') delete params[key]
    //     })
    //
    //     return $$.get(baseUrl + 'list', params)
    // },
    // tree: (params) => {
    //     Object.keys(params).map(key => {
    //         if (!params[key] || params[key] == 'null' || params[key] == 'undefined') delete params[key]
    //     })
    //
    //     return $$.get(baseUrl + 'tree', params)
    // },
    // listHome: (params) => {
    //     return $$.get(baseUrl + 'list-home', params)
    // },
    // treeHome: (params) => {
    //     return $$.get(baseUrl + 'tree-home', params)
    // },
    // listCategoryUnit: (params) => {
    //     return $$.get(baseUrl + 'list-category-unit', params)
    // },
    // update: (params) => {
    //     formatUnitParams(params)
    //     return $$.post(baseUrl + 'update', params)
    // },
    v2,leader,group
}

// function formatUnitParams(params) {
//     const unitLeaderList = [];
//     params.unitLeaderList && params.unitLeaderList.map(item => {
//         if (item.push) {
//             item.pushTel = false;
//             item.pushSms = false;
//             item.push.map(key => {
//                 item[key] = true
//             })
//         }
//         delete item.push;
//         unitLeaderList.push(item)
//     });
//     params.unitLeaderList = unitLeaderList
//
//     if (params.unitLeaderList && params.unitLeaderList.length) {
//         const unitLeaderList = params.unitLeaderList
//         unitLeaderList.map((item, index) => {
//             Object.keys(item).map(key => {
//                 params[`unitLeaderList[${index}].${key}`] = item[key]
//             })
//             delete params.unitLeaderList
//         })
//     }
// }